import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Box, Typography } from '@mui/material';

interface ReportDialogProps {
  open: boolean;
  onClose: () => void;
  issueDescription: string;
  onChange: (value: string) => void;
  onSubmitAttempt: () => void;
  selectedCount: number;
}

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedCount: number;
}

export const ReportIssueDialog: React.FC<ReportDialogProps> = ({ open, onClose, issueDescription, onChange, onSubmitAttempt, selectedCount }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Report Issue</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3, mt: 1, p: 1, borderRadius: 2 }}>
          <Typography variant="h5" align="center">
            <b>{selectedCount}</b> Device{selectedCount > 1 ? 's' : ''} Selected
          </Typography>
        </Box>
        <DialogContentText>
          Describe the issue with the selected device{selectedCount > 1 ? 's' : ''}. This will be reported for all selected devices.
        </DialogContentText>
        <Box sx={{ mt: 2 }}>
          <textarea
            id="issue-description"
            style={{ width: '100%', minHeight: 120, padding: 8 }}
            value={issueDescription}
            onChange={(e) => onChange(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined">Cancel</Button>
        <Button onClick={onSubmitAttempt} color="primary" variant="contained">Submit</Button>
      </DialogActions>
    </Dialog>
  );
};

export const ConfirmReportDialog: React.FC<ConfirmDialogProps> = ({ open, onClose, onConfirm, selectedCount }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Issue Report</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to report this issue for {selectedCount} selected device{selectedCount > 1 ? 's' : ''}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined">Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained">Confirm Report</Button>
      </DialogActions>
    </Dialog>
  );
};






